import { render, staticRenderFns } from "./TabViewLayout.vue?vue&type=template&id=5cff8dda&scoped=true&"
import script from "./TabViewLayout.vue?vue&type=script&lang=js&"
export * from "./TabViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabViewLayout.vue?vue&type=style&index=0&id=5cff8dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff8dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cff8dda')) {
      api.createRecord('5cff8dda', component.options)
    } else {
      api.reload('5cff8dda', component.options)
    }
    module.hot.accept("./TabViewLayout.vue?vue&type=template&id=5cff8dda&scoped=true&", function () {
      api.rerender('5cff8dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TabViewLayout.vue"
export default component.exports